import React from 'react';
import Typography from '../typography/typography';
import ExploreButton from './ExploreButton';
import useExplorePicker from './useExplorePicker';
import { FocusContext } from '@noriginmedia/norigin-spatial-navigation';
import { NetworkErrorDialog } from '@smart-tv/components/error-dialog/network-error-dialog';
import ErrorDialogExplorePicker from './ErrorDialogExplorePicker';
import useNetwork from '@smart-tv/hooks/use-network/use-network';
import { useSetAtom } from 'jotai';
import { headerActiveAtom } from '@smart-tv/atoms';
import { links } from '@smart-tv/components/header/header-navigation';
import { HEADER_EXPLORE } from '@smart-tv/components/header/header-helpers';
import styles from './explore-picker.module.scss';
import { testIds } from '@smart-tv/e2e/shared/variables';

// Derived from links instead of hardcoded, since its position can change (e.g. Søg).
const EXPLORE_INDEX = links.findIndex((link) => link.focusKey === HEADER_EXPLORE);



const ExplorePicker = () => {
  const {
    navigationContent,
    handleNavigationClick,
    ref,
    focusKey,
    selectedUniverse,
    error,
    retryFetchNavigationContent
  } = useExplorePicker();

  const { isOffline, isNetworkDialogSuppressed, setIsNetworkDialogSuppressed } = useNetwork();
  const setHeaderActive = useSetAtom(headerActiveAtom);

  return (
    <div className={styles['explore-picker']}>
      <div className={styles['title-root']}>
        <Typography variant="h2" className={styles['title']} data-testid={testIds.explorePicker.title}>
          Kategorier
        </Typography>
        <Typography variant="body">Fri adgang som en del af dit abonnement</Typography>
      </div>
      <FocusContext.Provider value={focusKey}>
        <div className={styles['button-container']} ref={ref}>
          {navigationContent?.map(({ id, title }, index) => (
            <ExploreButton
              key={`${title}-${index}`}
              focusKey={`${title}-focus-key`}
              title={title}
              handleClick={() => {
                handleNavigationClick(id, title);
              }}
            />
          ))}
        </div>
      </FocusContext.Provider>
      {isOffline && !isNetworkDialogSuppressed && (
        <NetworkErrorDialog
          onTryAgain={() => handleNavigationClick(selectedUniverse.id, selectedUniverse.title)}
          setNetworkStatusOnRetry={true}
          onClose={() => {
            // set header active to 'Udforsk' universe
            setHeaderActive(EXPLORE_INDEX);
            setIsNetworkDialogSuppressed(true);
          }}
        />
      )}
      {!navigationContent?.length && (
        <ErrorDialogExplorePicker error={error} reloadUniverseCategories={retryFetchNavigationContent} />
      )}
    </div>
  );
};

export default ExplorePicker;
